import React, { Component } from "react";
import injectSheet from "react-jss";
// import Color from 'color'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import Thumbnails from "./Thumbnails";
import ScrollableAnchor from "react-scrollable-anchor";
import { configureAnchors } from "react-scrollable-anchor";
import styled from 'styled-components'
import { isMobile } from "react-device-detect";
configureAnchors({ offset: -60, scrollDuration: 700 });

const Edit = styled.div.attrs({
  className: "fas fa-edit"
})`
  transition: all .7s;
  color: ${palette.white};
  font-size: 1.5vw;
  margin-left: 1vw;
  opacity: ${props => props.opacity};
  &:hover {
    color: ${palette.blue};
    cursor: pointer;
  }
`

const TitleContainer = styled.div`
  width: 100vw;
  padding-left: ${ props => props.isMobile ? '1vw' : '4.5vw' };
  margin-top: ${ props => props.isMobile ? '2vw' : '.5rem' };
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 1;
`

const Title = styled.div.attrs({
  children: props => props.title
})`
  color: ${palette.white};
  font-size: ${props => props.isMobile ? '3vw' : '2vw'};
  zIndex: 2;
`;

const SubTitle = styled.div.attrs({
  children: 'my playlist'
})`
  color: ${palette.white};
  margin-top: ${props => props.isMobile ? '.5vw' : '.8vw'};
  margin-left: ${props => props.isMobile ? '1vw' : '1vw'};
  font-style: italic;
  font-size: .8vw;
`

class ShowView extends Component {
  state = { 
    opacity: '0'
  }
  render() {
    const { classes } = this.props;
    const { Body } = classes;
    return (
      <ScrollableAnchor id={`ThumbNail_${this.props.index}`}>
        <div onMouseLeave={()=>{this.setState({opacity: '0'})}} onMouseOver={()=>{this.setState({opacity: '1'})}} className={Body}>
          <TitleContainer isMobile={isMobile}>
            <Title isMobile={isMobile} title={this.props.view.title}/>
            {/* {this.props.view.type === "playlist"
                ? <SubTitle/>
                : null} */}
            <div className={classes.title}>
              {this.props.view.type === "playlist"
                ? <Edit onClick={this.editPlaylist} opacity={this.state.opacity}/>
                : null}
            </div>
          </TitleContainer>
          <Thumbnails
            rowNum={this.props.index}
            section={this.props.view.title}
            thumbNails={this.props.view.contentList}
          />
        </div>
      </ScrollableAnchor>
    );
  }

  editPlaylist = () => {    
    // console.log(this.props.view.type)
    // console.log(this.props.history)
    this.props.history.push(`/Home/playlists/${this.props.view.title}`)
  }

}

const styles = {
  ...flexUtils,
  Body: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    flex: "2",
    width: "100vw"
  },
  titleContainer: {
    width: "100vw",
    paddingLeft: "4.5vw",
    marginTop: ".5rem",
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    zIndex: "1"
  },
  title: {
    color: palette.white,
    fontSize: "2vw",
    zIndex: "2"
  }
};

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library
  };
};

export default withRouter(
  withRouter(connect(mapStateToProps)(injectSheet(styles)(ShowView)))
);



// WEBPACK FOOTER //
// ./src/js/Components/Home/Shows/ShowView.jsx